import React from "react"

export default function Notification() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
         <g clipPath="url(#clip0_171_8938)">
            <path d="M12.1929 21.7393C13.4346 21.7393 14.4418 20.732 14.4418 19.4893H9.94394C9.94394 20.732 10.9512 21.7393 12.1929 21.7393ZM19.7652 16.476C19.086 15.7462 17.8151 14.6482 17.8151 11.0518C17.8151 8.32012 15.8998 6.1334 13.3172 5.59691V4.86426C13.3172 4.24305 12.8137 3.73926 12.1929 3.73926C11.572 3.73926 11.0686 4.24305 11.0686 4.86426V5.59691C8.48602 6.1334 6.57071 8.32012 6.57071 11.0518C6.57071 14.6482 5.29981 15.7462 4.62059 16.476C4.40965 16.7028 4.31614 16.9738 4.3179 17.2393C4.32176 17.8158 4.77422 18.3643 5.44641 18.3643H18.9394C19.6115 18.3643 20.0644 17.8158 20.0679 17.2393C20.0696 16.9738 19.9761 16.7024 19.7652 16.476Z" fill="#5B5E71" />
         </g>
         <defs>
            <clipPath id="clip0_171_8938">
               <rect width="15.75" height="18" fill="white" transform="translate(4.3186 3.73926)" />
            </clipPath>
         </defs>
      </svg>
   )
}
